import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import type { ReactElement, VoidFunctionComponent } from 'react';

import { type ReleaseGroup } from '../../../../../../shared/projectsV2';
import * as ProjectV2Store from '../../../../../redux/projectsV2';
import Checkbox from '../../../../generic/Forms/Checkbox';
import Tooltip from '../../../../generic/Tooltip';
import WaitingToScan from '../ScanStatus/WaitingToScan';
import type { ReduxStore } from '../../../../../redux/store';

import ReleaseGroupIssueCounts from './ReleaseGroupIssueCounts';
import ReleaseGroupOverview from './ReleaseGroupOverview';

type Props = {
  releaseGroup: ReleaseGroup;
};

const ProjectItem: VoidFunctionComponent<Props> = ({ releaseGroup }: Props) => {
  const dispatch = useDispatch();
  const isSelected =
    useSelector((state: ReduxStore) => ProjectV2Store.selectors.getIsProjectSelected(state, String(releaseGroup.id)));
  const scanned: string | ReactElement = releaseGroup.scanned ? (
    moment(releaseGroup.scanned).fromNow()
  ) : (
    <WaitingToScan />
  );
  const scannedTooltipText: string = releaseGroup.scanned
    ? moment(releaseGroup.scanned).format('MMM Do, YYYY [at] HH:mm:ss')
    : 'Release Group has not been scanned yet.';

  const onSelect = () => isSelected
    ? dispatch(ProjectV2Store.actions.deselectProject(String(releaseGroup.id)))
    : dispatch(ProjectV2Store.actions.selectProject(String(releaseGroup.id)));

  return (
    // The checkbox allows for keyboard accessibility.
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div className="release-group-item" onClick={onSelect}>
      <div className="release-group-item__checkbox">
        <Checkbox isChecked={isSelected} isRippleDisabled />
      </div>
      <ReleaseGroupOverview releaseGroup={releaseGroup} />
      <ReleaseGroupIssueCounts releaseGroup={releaseGroup} />
      <div>
        <Tooltip id="release-group-item-tooltip" tooltip={scannedTooltipText}>
          <span className="release-group-item__scanned">
            {scanned}
          </span>
        </Tooltip>
      </div>
    </div>
  );
};

export default ProjectItem;
